import { Button } from 'antd'
import { Pencil, Printer } from 'lucide-react'
import { useFFEStore } from '../../store/ffeStore'

export const PreviewButton = () => {
  const isPreviewing = useFFEStore((state) => state.isPreviewing)
  const setIsPreviewing = useFFEStore((state) => state.setIsPreviewing)
  if (isPreviewing) {
    return (
      <Button
        icon={<Pencil className="h-4 w-4"></Pencil>}
        onClick={() => setIsPreviewing(false)}
      >
        Exit Preview
      </Button>
    )
  }
  return (
    <Button
      icon={<Printer className="h-4 w-4" />}
      onClick={() => setIsPreviewing(true)}
    >
      Preview
    </Button>
  )
}
